import { jsxs as r, jsx as e } from "react/jsx-runtime";
import { forwardRef as c } from "react";
import { NumberInput as d, NumberInputField as f, NumberInputStepper as I, NumberDecrementStepper as x, NumberIncrementStepper as h } from "@chakra-ui/react";
const S = c((t, m) => {
  const {
    defaultValue: n,
    min: p,
    max: u,
    onChange: i,
    precision: o,
    size: a = "md",
    step: s,
    value: l,
    variant: N = "outline",
    ...b
  } = t;
  return /* @__PURE__ */ r(
    d,
    {
      defaultValue: n,
      min: p,
      max: u,
      onChange: i,
      precision: o,
      size: a,
      step: s,
      value: l,
      variant: N,
      children: [
        /* @__PURE__ */ e(f, { ref: m, ...b }),
        /* @__PURE__ */ r(I, { children: [
          /* @__PURE__ */ e(x, {}),
          /* @__PURE__ */ e(h, {})
        ] })
      ]
    }
  );
});
S.displayName = "NumberInputBase";
export {
  S as NumberInputBase
};
